import React from 'react';
import { transformHref } from '../../../lib/html.utils';

const DetailsField = ({ field, value, link, target, tags }) => {
    if (value) {
        return (
            <div className="ckp-admin-grid-row">
                <span className="ckp-admin-forms-show-key ckp-ts-h3 u-bold">{field}</span>
                {link ? (
                    <a
                        href={transformHref(link)}
                        target={target}
                        className="ckp-admin-forms-show-value-link u-truncate"
                    >
                        {value}
                    </a>
                ) : tags ? (
                    <p className="ckp-admin-forms-show-tags">
                        {value.map(x => (
                            <span key={x} className="ckp-admin-forms-show-tag">
                                {x}
                            </span>
                        ))}
                    </p>
                ) : (
                    <p className="ckp-admin-forms-show-value u-truncate">{value}</p>
                )}
            </div>
        );
    } else {
        return null;
    }
};

export default DetailsField;
